export { WIYWFullResults } from './WIYWFullResults';
